import React, { useState ,useEffect }  from "react";
import "./controlPatiosInventarioCajas.css"
import IconLibrary from "../../shared/iconLibrary";
import {useAuth} from "../../Seguridad/AuthProvider";

import { useNavigate } from "react-router-dom";
import useApiInventariosCaja from "../../api/taller/useApiInventariosCaja"
const ControlPatiosInventarioCajasIpad = () => {
    const history = useNavigate();
    const api = useApiInventariosCaja();
    const [patios, setPatios] = useState([]);
    const auth = useAuth();
    const user = auth?.user ?? {};

  useEffect(() => {
    async function cargar() {
      try {
        
        const getPatios = await api.getPatios(user.username);
      
        setPatios(getPatios);
      } catch (err) {
        console.error("Error al cargar patios:", err);
      }
    }
    cargar();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    async function nuevo(patio) {
        history("/controlPatiosInventarioCajas/nuevo/" + patio.id);
    }

   return (
    <div className="patios-wrap">
        <div className="ope-menu-patios patios-grid">
            {patios.map(patio => (
            <button
                key={patio.id}
                className="ope-item-menu-patios patio-tile shadow"
                onClick={() => nuevo(patio)}
                type="button"
            >
                <span className="patio-title">{patio.nombre}</span>
                <span className="patio-icon"><IconLibrary iconName="ImLocation2" /></span>
            </button>
            ))}
        </div>
        </div>

        );
};

export default ControlPatiosInventarioCajasIpad;

